import { Fragment, type ReactNode } from 'react';
import { FeatherIcon } from './FeatherIcon';
import { C, FONT } from './ChatAssistant/compact/tokens';
import './ChatAssistant/compact/compact.css';

export interface SubTab {
  id: string;
  label: string;
  icon: string;
  disabled?: boolean;
  title?: string;
  badge?: ReactNode;
  /** Draw a separator before this tab (sets apart a tab that isn't a settings page). */
  divider?: boolean;
}

interface SubTabBarProps {
  tabs: SubTab[];
  active: string;
  onChange: (id: string) => void;
}

/* The bar hugs its tabs; when they outgrow the row it scrolls sideways (mobile-scroll-row)
   rather than wrapping. Wrapping a fit-content bar is what stacked the tabs vertically. */
export function SubTabBar({ tabs, active, onChange }: SubTabBarProps) {
  return (
    <nav
      className="mobile-scroll-row"
      style={{
        display: 'flex', width: 'fit-content', flexWrap: 'nowrap', gap: 3, padding: 5, marginBottom: 12,
        background: C.card, border: `1px solid ${C.borderLo}`, borderRadius: 10,
      }}
    >
      {tabs.map((tab) => {
        const on = tab.id === active;
        return (
          <Fragment key={tab.id}>
          {tab.divider && <span aria-hidden style={{ width: 1, flex: 'none', alignSelf: 'stretch', background: C.borderHi, margin: '5px 2px' }} />}
          <button
            type="button"
            onClick={() => onChange(tab.id)}
            disabled={tab.disabled}
            title={tab.title}
            aria-current={on ? 'page' : undefined}
            className={on || tab.disabled ? undefined : 'cpt-hover-text'}
            style={{
              flex: '0 0 auto', minHeight: 32, padding: '3px 14px', border: 0, borderRadius: 6, whiteSpace: 'nowrap',
              background: on ? C.tint20 : 'transparent', color: on ? C.purpleLt : C.sub,
              font: `500 12px/1.2 ${FONT}`, cursor: tab.disabled ? 'not-allowed' : 'pointer', opacity: tab.disabled ? 0.5 : 1,
              display: 'flex', alignItems: 'center', gap: 6,
            }}
          >
            <FeatherIcon name={tab.icon} size={13} />
            <span>{tab.label}</span>
            {tab.badge}
          </button>
          </Fragment>
        );
      })}
    </nav>
  );
}
